var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 31H30C30.5523 31 31 30.5523 31 30V12.8036L23.5215 5H13C12.4477 5 12 5.44772 12 6V30C12 30.5523 12.4477 31 13 31ZM24.375 3L33 12V30C33 31.6569 31.6569 33 30 33H13C11.3431 33 10 31.6569 10 30V6C10 4.34315 11.3431 3 13 3H24.375Z",
    fill: "#2D7EF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4H24V13H32V15H22V4Z",
    fill: "#2D7EF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14V4H24L32 12V14H23Z",
    fill: "#2D7EF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 17.1429,
    height: 16,
    fill: "#2D7EF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1034 15.4852V23.6712H9.48584V15.4852H5.78644V12.6712H16.7864V15.4852H13.1034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFileIcon);
export default __webpack_public_path__ + "static/media/TextFileIcon.c87b7f046173567d488979bd57c278f4.svg";
export { ForwardRef as ReactComponent };